import type { SVGProps } from 'react';

const SvgStatusGeneric = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentcolor" d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />
  </svg>
);
export default SvgStatusGeneric;
